import $ from 'zzc-zepto';
import Events from 'zzc-arale-events';
import {
  isUndefined
} from './typeof';

// let supportsPassive = false;
// try {
//     let opts = Object.defineProperty({}, 'passive', {
//         get: function () {
//             supportsPassive = true;
//         }
//     });
//     window.addEventListener('test', null, opts);
// } catch (e) {}

const event = new Events();

const cache = {};

function normalization(selector) {
  const isEmptyString = selector === '';
  const isWindow = selector === 'window' || selector === window;
  if (isEmptyString || isWindow) {
    selector = 'window';
  }

  return selector;
}

function createEventName(selector) {
  return `scroll.${selector}`;
}

function getElement(selector = '') {
  if (!selector) {
    return new Error('getElement function key is invalid');
  }
  if (!cache[selector]) {
    cache[selector] = $((selector === 'window' ? window : selector));
  }
  return cache[selector];
}

const bindCache = {};
export function bind(selector = '', cb) {
  selector = normalization(selector);

  const eventName = createEventName(selector);

  event.on(eventName, cb);

  if (!bindCache[eventName]) {
    const $el = getElement(selector);

    // let useCapture = supportsPassive ? {passive: true} : false;
    // $el.on(eventName, function (e) {
    //     event.trigger(eventName, {
    //         context: this,
    //         event: e
    //     });
    // }, useCapture);
    // debugger;
    $el.on(eventName, (e) => {
      event.trigger(eventName, {
        context: this,
        event: e
      });
    });
    bindCache[eventName] = 1;
  }
}

export function unbind(selector = '') {
  selector = normalization(selector);

  const eventName = createEventName(selector);
  if (cache[eventName]) {
    event.off(eventName);

    const $el = getElement(selector);
    $el.off(eventName);
    cache[selector] = null;

    bindCache[eventName] = 0;
  }
}

export function scrollToAnimate(selector = '', x, y, duration = 400) {
  selector = normalization(selector);
  if (selector === 'window') {
    selector = 'html, body';
  }
  const $el = getElement(selector);
  isUndefined(x) || $el.animate({
    scrollLeft: x
  }, duration);
  isUndefined(y) || $el.animate({
    scrollTop: y
  }, duration);
}
export function scrollLeftAnimate(selector = '', x, duration) {
  scrollToAnimate(selector, x, undefined, duration);
}
export function scrollTopAnimate(selector = '', y, duration) {
  scrollToAnimate(selector, undefined, y, duration);
}

/**
 * XY轴滚动
 * @param selector
 * @param x
 * @param y
 */
export function scrollTo(selector = '', x, y) {
  selector = normalization(selector);

  const $el = getElement(normalization(selector));
  isUndefined(x) || $el.scrollLeft(x);
  isUndefined(y) || $el.scrollTop(y);
}

/**
 * X轴滚动
 * @param selector
 * @param x
 */
export function scrollLeft(selector, x) {
  if (x === undefined) {
    const $el = getElement(normalization(selector));
    return $el.scrollLeft();
  }
  return scrollTo(selector, x, undefined);
}

/**
 * Y轴滚动
 * @param selector
 * @param y
 */
export function scrollTop(selector, y) {
  if (y === undefined) {
    const $el = getElement(normalization(selector));
    return $el.scrollTop();
  }
  return scrollTo(selector, undefined, y);
}
